import * as React from 'react';
import classNames from 'clsx';
import { SkeletonBase } from './SkeletonBase';
import type { SkeletonTextSharedProps } from './SkeletonText.types';
import type { Size } from './skeleton-config';

const sizeClasses: Record<Size, string> = {
  xxs: 'h-4',
  xs: 'h-6',
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
  xl: 'h-14',
  xxl: 'h-16',
};

export type SkeletonTextProps = SkeletonTextSharedProps;

export const SkeletonText = ({ size, className, ...props }: SkeletonTextProps) => (
  <SkeletonBase {...props} className={classNames('rounded-md w-full', sizeClasses[size], className)} />
);
